"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cx } from "../internal/cx.js";
/** A wrapping row of metrics, badges and buttons (on top of `.jui-row`); `end` stays on the right. */
export function Toolbar({ children, end, label, dense, className }) {
    return _jsxs("div", { className: cx("jui-row", "jui-toolbar", dense && "jui-toolbar--dense", className), role: label ? "toolbar" : undefined, "aria-label": label, children: [children, end && _jsx("span", { className: "jui-toolbar-end", children: end })] });
}
